import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

//nav animator
let selectedLink = null;
const nav = document.querySelector('.navbar');

function animateIn(beforeSpan, listSpan) {
const tl = gsap.timeline();
tl.to(beforeSpan, {
    y: -40,
    duration: 0.3,
    overwrite: "auto",
})
.to(listSpan, {
    color: "#1E201E",
    duration: 0.3,
    overwrite: "auto",
}, "<")
.to(listSpan, {
    "--after-opacity": 1,
    "--before-opacity": 1,
    duration: 0.3,
    overwrite: "auto",
}, "<");
}

function animateOut(beforeSpan, listSpan) {
const tl = gsap.timeline();
tl.to(beforeSpan, {
    y: 0,
    duration: 0.3,
    overwrite: "auto",
})
.to(listSpan, {
    color: "#000000",
    duration: 0.3,
    overwrite: "auto",
}, "<")
.to(listSpan, {
    "--after-opacity": 1,
    "--before-opacity": 1,
    duration: 0.3,
    overwrite: "auto",
}, "<");
}

document.addEventListener("DOMContentLoaded", function () {
    const LI = document.querySelectorAll(".navbar nav ul li");

    LI.forEach((li) => {
        const listItem = li.querySelector("li");
        const link = li.querySelector("a");
        const beforeSpan = li.querySelector(".before-span");
        const listSpan = beforeSpan?.querySelector("span");

        if (!link || !beforeSpan || !listSpan) return;

        link.addEventListener("mouseenter", () => {
            if (link !== selectedLink && selectedLink) {
            const selectedBefore = selectedLink.querySelector(".before-span");
            const selectedSpan = selectedBefore?.querySelector("span");
            if (selectedBefore && selectedSpan) animateOut(selectedBefore, selectedSpan);
            }

            animateIn(beforeSpan, listSpan);
        });

        link.addEventListener("mouseleave", () => {
            if (link !== selectedLink) {
                animateOut(beforeSpan, listSpan);

                if (selectedLink) {
                    const selectedBefore = selectedLink.querySelector(".before-span");
                    const selectedSpan = selectedBefore?.querySelector("span");
                    if (selectedBefore && selectedSpan) animateIn(selectedBefore, selectedSpan);
                }
            }
        });
    });

    function logCurrentPageLink() {
    // e.g. ".../web-build/services/index.html" -> ["web-build", "services", "index.html"]
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    const currentFile = pathSegments[pathSegments.length - 1] || "index.html";
    const currentFolder = pathSegments.length > 1 ? pathSegments[pathSegments.length - 2] : null;
    console.log("Current page:", currentFile, "in folder:", currentFolder);

    const navLinks = document.querySelectorAll(".navbar ul li a");
    console.log("Found links:", navLinks.length);

    navLinks.forEach(link => {
        const href = link.getAttribute("href");
        if (!href) return;

        const hrefSegments = href.split("/").filter(Boolean);
        const hrefFile = hrefSegments[hrefSegments.length - 1];
        const hrefFolder = hrefSegments.length > 1 ? hrefSegments[hrefSegments.length - 2] : null;
        console.log("Checking href:", href, "-> file:", hrefFile, "folder:", hrefFolder);

        // Every page is named index.html, so the file name alone can't tell
        // pages apart — the parent folder has to match too.
        if (hrefFile === currentFile && hrefFolder === currentFolder) {
            console.log("Current page link:", link);
            selectedLink = link;

            const beforeSpan = link.querySelector(".before-span");
            const listSpan = beforeSpan?.querySelector("span");
            console.log("there is a match at:", selectedLink);

            if (beforeSpan && listSpan) {
                animateIn(beforeSpan, listSpan); // Animate default selected link
            }
        }
    });
    }
        logCurrentPageLink();
});

const content  = document.querySelector('.smooth-content');
const viewbox  = document.querySelector('.viewbox');

// --- state ---
// let current  = 0;
// let target   = 0;  
// let maxScroll = 0;

// const ease = 0.2; 





// window.addEventListener('wheel', (e) => {
//     e.preventDefault();

//     const maxScroll = viewbox.scrollHeight - viewbox.clientHeight;
//     target += e.deltaY;
//     target = Math.max(0, Math.min(target, maxScroll));

//     }, { passive: false });

//     gsap.ticker.add(() => {
//     // lerp current toward target each frame
//     current = gsap.utils.interpolate(current, target, .1);
//     viewbox.scrollTop = current;
// });

// gsap.ticker.lagSmoothing(0); // prevents big jumps after tab loses focus
// // touch support
// let touchStartY = 0;
// window.addEventListener('touchstart', e => { touchStartY = e.touches[0].clientY; });
// window.addEventListener('touchmove', e => {
//     e.preventDefault();
//     const delta = touchStartY - e.touches[0].clientY;
//     touchStartY  = e.touches[0].clientY;
//     target = clamp(target + delta, 0, maxScroll);
// }, { passive: false });

//     window.addEventListener('wheel', (e) => {
//     e.preventDefault();
//     target = clamp(target + e.deltaY, 0, maxScroll);
//   gsap.to(content, {
//     y: -target,
//     duration: 1,
//     ease: 'power3.out',
//     overwrite: 'auto'
//   });
// }, { passive: false });

// Hamburger Menu Animation //
const hamburger = document.querySelector(".hamburger");
const navMenu = document.querySelector(".mobile-navbar");
const mobileNav = document.getElementById('mobile-navbar');
const navElements = mobileNav.querySelectorAll('ul li');


if (hamburger) {
        hamburger.addEventListener('click', () => {
            if (navMenu.classList.contains('active')) closeNav();
            else openNav();
    });
}
function openNav() {
    hamburger.classList.add('active');
    navMenu.classList.add('active');
    viewbox.classList.add('active');
}

function closeNav() {
    hamburger.classList.remove('active');
    navMenu.classList.remove('active');
    viewbox.classList.remove('active');
}


// Close the mobile menu when a nav link is clicked
const navLinks = document.querySelectorAll('.list a');
navLinks.forEach(link => {
    link.addEventListener('click', () => {
        closeNav();
    });
});
const mobileQuery = window.matchMedia('(max-width: 640px)');
mobileQuery.addEventListener('change', (e) => {
    if (!e.matches) closeNav(); // crossed back to desktop
});

// Close menu on Escape key
document.addEventListener('keydown', (e) => {
if (e.key === 'Escape') closeNav();
});
/* Mobile Nav Animation */
console.log("is this thing on?");